module.exports = __webpack_public_path__ + "img/TRUSTMUTUALLIFE.03d8dda6.jpg";